import './index.scss';

import React from 'react';
import { lang, isSystem } from '@umu/ukit-lang';

interface IProps {
    closeDialog(): void;
    data: {
        offline_date: string;
    };
}
export class LevelPrivilegeOffline extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);

        this.onClose = this.onClose.bind(this);
    }

    onClose() {
        this.props.closeDialog();
    }

    render() {
        const data = this.props.data;
        let desc = lang(
            `感谢您对UMU的支持与厚爱。我们将于 <span>$0</span> 开始对“不限量互动数据下载”和“不限量视频上传”功能进行收费。如果您要继续使用这两个功能，请于$0之前完成 <a href="/plan/pricing">付费升级</a>，同时享受更多高级功能；为回馈老用户，UMU上线了限时8折购买专业版优惠活动。如暂无升级计划，请于$0之前完成数据的下载保存。`,
        ).replace(/\$0/g, data.offline_date);
        if (!isSystem('CN')) {
            desc = lang(
                `感谢您对UMU的支持与厚爱。我们将于 <span>$0</span> 开始对“不限量互动数据下载”和“不限量视频上传”功能进行收费。如果您要继续使用这两个功能，请于$0之前完成 <a href="/plan/pricing" target="_blank">付费升级</a>，同时享受更多高级功能；如暂无升级计划，请于$0之前完成数据的下载保存。`,
            ).replace(/\$0/g, data.offline_date);
        }
        const eduDesc = lang(
            `如果您是在职教师或教育工作者，欢迎加入 <a href="/home/edu">UMU教育计划</a>，免费升级教育专业版，享受高级功能。UMU持续致力于用科技的力量创新教育信息化，让广大师生受益。`,
        );
        return (
            <div className="level-privilege-offline">
                <div className="title">{lang('重要通知')}</div>
                <div className="desc head">{lang('尊敬的用户您好：')}</div>
                <div className="level-privilege-desc">
                    <p className="desc" dangerouslySetInnerHTML={{ __html: desc }}></p>
                    <p className="desc" dangerouslySetInnerHTML={{ __html: eduDesc }}></p>
                </div>
                <div className="operation">
                    <button className="btn btn-optional" onClick={this.onClose}>
                        {lang('取消')}
                    </button>
                    <a className="btn btn-warning" href="/plan/pricing">
                        {lang('去升级')}
                    </a>
                </div>
            </div>
        );
    }
}
